// Libraries
import I18n from 'i18next'
import { defaultTo, get, map } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { message } from 'antd'

// Resources
import { actions as extractionActions } from 'Resources/ExtractionResource'
import { actions as companyActions } from 'Resources/CompanyResource'

// Ãcrans
import { List } from './Screens'

class ExtractionConstructor extends Component {
  static propTypes = {
    // Actions d'API
    actions: PropTypes.object,

    // TÃ©moins d'activitÃ© API
    isExportingPermits: PropTypes.bool,
    isExportingPdps: PropTypes.bool,
    isExportingCompanies: PropTypes.bool,

    // DonnÃ©es
    companies: PropTypes.array,

    // Navigation interne
    navigation: PropTypes.shape({
      navigate: PropTypes.func.isRequired,
      getParam: PropTypes.func.isRequired,
      setParams: PropTypes.func.isRequired
    })
  }

  static defaultProps = {
    actions: {},
    isExportingPermits: false,
    isExportingPdps: false,
    isExportingCompanies: false,
    companies: []
  }

  constructor(props) {
    super(props)

    this.state = {
      // Permis
      permitsDateFrom: null,
      permitsDateTo: null,
      permitsCompanyId: null,
      permitsPermitType: 'all_permit',

      // Plans de prÃ©vention
      pdpsDateFrom: null,
      pdpsDateTo: null,
      pdpsCompanyId: null,

      // Entreprises
      companiesDateFrom: null,
      companiesDateTo: null
    }
  }

  componentDidMount = () => {
    this.props.actions.fetchAllCompanies().catch(() => {
      message.error(I18n.t('api.errors.companie.fetch'))
    })
  }

  /**
   * DÃ©clenche le tÃ©lÃ©chargement d'un CSV Ã  partir du contenu brut
   */
  _triggerDownload = (data, filename) => {
    const url = window.URL.createObjectURL(
      new Blob([data], { type: 'text/csv;charset=utf-8;' })
    )
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  }

  /**
   * TÃ©lÃ©chargement de l'export des permis
   */
  downloadPermits = () => {
    const { permitsDateFrom, permitsDateTo, permitsCompanyId, permitsPermitType } = this.state
    const query = {}

    if (permitsDateFrom) query.date_from = permitsDateFrom.format('YYYY-MM-DD')
    if (permitsDateTo) query.date_to = permitsDateTo.format('YYYY-MM-DD')
    if (permitsCompanyId) query.company_id = permitsCompanyId
    if (permitsPermitType) query.permit_type = permitsPermitType

    this.props.actions
      .exportPermitsExtraction({}, { query })
      .then(({ body }) => {
        this._triggerDownload(body, 'permits_export.csv')
      })
      .catch(() => {
        message.error(I18n.t('api.errors.extraction.download'))
      })
  }

  /**
   * TÃ©lÃ©chargement de l'export des plans de prÃ©vention
   */
  downloadPdps = () => {
    const { pdpsDateFrom, pdpsDateTo, pdpsCompanyId } = this.state
    const query = {}

    if (pdpsDateFrom) query.date_from = pdpsDateFrom.format('YYYY-MM-DD')
    if (pdpsDateTo) query.date_to = pdpsDateTo.format('YYYY-MM-DD')
    if (pdpsCompanyId) query.company_id = pdpsCompanyId

    this.props.actions
      .exportPdpsExtraction({}, { query })
      .then(({ body }) => {
        this._triggerDownload(body, 'pdps_export.csv')
      })
      .catch(() => {
        message.error(I18n.t('api.errors.extraction.download'))
      })
  }

  /**
   * TÃ©lÃ©chargement de l'export des entreprises
   */
  downloadCompanies = () => {
    const { companiesDateFrom, companiesDateTo } = this.state
    const query = {}

    if (companiesDateFrom) query.date_from = companiesDateFrom.format('YYYY-MM-DD')
    if (companiesDateTo) query.date_to = companiesDateTo.format('YYYY-MM-DD')

    this.props.actions
      .exportCompaniesExtraction({}, { query })
      .then(({ body }) => {
        this._triggerDownload(body, 'companies_export.csv')
      })
      .catch(() => {
        message.error(I18n.t('api.errors.extraction.download'))
      })
  }

  render() {
    const { isExportingPermits, isExportingPdps, isExportingCompanies, companies } = this.props

    const companyOptions = map(companies, ({ name, id }) => ({ value: id, label: name }))

    const constructorFunctions = {
      downloadPermits: this.downloadPermits,
      setPermitsDateFrom: permitsDateFrom => this.setState({ permitsDateFrom }),
      setPermitsDateTo: permitsDateTo => this.setState({ permitsDateTo }),
      setPermitsCompanyId: permitsCompanyId => this.setState({ permitsCompanyId }),
      setPermitsPermitType: permitsPermitType => this.setState({ permitsPermitType }),

      downloadPdps: this.downloadPdps,
      setPdpsDateFrom: pdpsDateFrom => this.setState({ pdpsDateFrom }),
      setPdpsDateTo: pdpsDateTo => this.setState({ pdpsDateTo }),
      setPdpsCompanyId: pdpsCompanyId => this.setState({ pdpsCompanyId }),

      downloadCompanies: this.downloadCompanies,
      setCompaniesDateFrom: companiesDateFrom => this.setState({ companiesDateFrom }),
      setCompaniesDateTo: companiesDateTo => this.setState({ companiesDateTo })
    }

    return (
      <List
        constructorFunctions={constructorFunctions}
        constructorState={{
          ...this.state,
          companyOptions,
          isDownloadingPermits: isExportingPermits,
          isDownloadingPdps: isExportingPdps,
          isDownloadingCompanies: isExportingCompanies
        }}
      />
    )
  }
}

const mapStateToProps = state => {
  const defaultProps = get(ExtractionConstructor, 'defaultProps', {})

  return {
    isExportingPermits: defaultTo(
      get(state, 'extraction.isExportingPermits'),
      defaultProps.isExportingPermits
    ),
    isExportingPdps: defaultTo(
      get(state, 'extraction.isExportingPdps'),
      defaultProps.isExportingPdps
    ),
    isExportingCompanies: defaultTo(
      get(state, 'extraction.isExportingCompanies'),
      defaultProps.isExportingCompanies
    ),
    companies: defaultTo(get(state, 'company.items'), defaultProps.companies)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...extractionActions, ...companyActions }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ExtractionConstructor)
